import { render, staticRenderFns } from "./ConventionItem.vue?vue&type=template&id=04a13d78&scoped=true&"
import script from "./ConventionItem.vue?vue&type=script&lang=js&"
export * from "./ConventionItem.vue?vue&type=script&lang=js&"
import style0 from "./ConventionItem.vue?vue&type=style&index=0&id=04a13d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a13d78",
  null
  
)

export default component.exports